import api from "../Api";

// جلب جميع الفئات
export const getCategories = async () => {
  try {
    const response = await api.get("/public/get/categories");
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

// جلب جميع المنتجات
export const getAllProducts = async (params = {}) => {
  try {
    // endpoint مطابق للصورة في المرفق
    const response = await api.get("/public/all-prodcuts", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching all products:", error);
    throw error;
  }
};

// جلب أفضل المنتجات مبيعاً
export const getBestSellingProducts = async (params = {}) => {
  try {
    const response = await api.get("/public/best-saleing-products", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching best selling products:", error);
    throw error;
  }
};

// جلب لافتات الإعلان
export const getAdvertisingBanners = async (params = {}) => {
  try {
    const response = await api.get("/public/get/advertising-banners", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching advertising banners:", error);
    throw error;
  }
};

// جلب منتجات فئة معينة
export const getCategoryProducts = async (categoryId, params = {}) => {
  try {
    const response = await api.get(`/public/category-prodcuts/${categoryId}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching category products:", error);
    throw error;
  }
};

// جلب بيانات بنر محدد مع المنتجات المرتبطة به
export const getBannerProducts = async (bannerId, params = {}) => {
  try {
    const response = await api.get(`/public/banners-products/${bannerId}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching banner products:", error);
    throw error;
  }
};

// ✅ Get Product Info (Public)
export const getProductInfo = async (productId) => {
  if (!productId) {
    throw new Error("productId is required");
  }

  const response = await api.get(`/public/prodcut-info/${productId}`, {
    params: {
      api_password: "EcommercApp@2026_$",
    },
    headers: {
      Accept: "application/json",
    },
  });

  return response.data;
};

// إنشاء رسالة تواصل (form-data)
export const createContactMessage = async ({ name, email, subject, message, file } = {}) => {
  try {
    const formData = new FormData();
    if (name !== undefined) formData.append("name", name);
    if (email !== undefined) formData.append("email", email);
    if (subject !== undefined) formData.append("subject", subject);
    if (message !== undefined) formData.append("message", message);
    if (file) formData.append("file", file);

    // استخدم نفس api_password الموجود في المشروع (عدل إذا لزم)
    const url = `/public/create/contact-us-message?api_password=EcommercApp@2026_$`;

    const response = await api.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating contact message:", error);
    throw error;
  }
};

// جلب الدول مع فئات الشحن
export const getCountriesWithShippingCategories = async (params = {}) => {
  try {
    // تضمين كلمة المرور كـ query param كما في بقية الدوال
    const mergedParams = { api_password: "EcommercApp@2026_$", ...params };
    const response = await api.get("/public/get-countries-with-shipping-categories", { params: mergedParams });
    return response.data;
  } catch (error) {
    console.error("Error fetching countries with shipping categories:", error);
    throw error;
  }
};